import { File02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon, IconSvgElement } from "@hugeicons/react";
import { Button, ButtonSize, ButtonVariant } from "shared/components";

export const NoRowsFallback = ({
  Icon,
  title = "No data",
  text = "There are no rows to display.",
  buttonText,
  buttonAction
}: {
  Icon?: IconSvgElement;
  title?: string;
  text?: string;
  buttonText?: string;
  buttonAction?: () => void;
}) => {
  return (
    <div className="col-span-full flex h-full flex-col items-center justify-center py-20">
      <div className="mb-6 flex items-center justify-center rounded-full bg-alpha-40 p-8">
        {Icon ? (
          <HugeiconsIcon
            icon={Icon as IconSvgElement}
            size={40}
            className="text-content-400"
          />
        ) : (
          <HugeiconsIcon
            icon={File02Icon}
            size={40}
            className="text-content-400"
          />
        )}
      </div>
      <p className="mb-2 text-base font-bold">{title}</p>
      <p className="text-sm font-medium text-content-300 text-center">{text}</p>

      {buttonText && buttonAction ? (
        <Button
          onClick={() => {
            buttonAction();
          }}
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.SM}
          className="mt-6"
        >
          {buttonText}
        </Button>
      ) : null}
    </div>
  );
};
